module.exports = __webpack_public_path__ + "76df9ba824fc4daffe9dd22da51ff641.jpg";